import ControlSlider from "./control-slider";
import { CONTROL_SLIDER_MARKER_PCTS } from "./slider-math";

// Normal: the slider runs 1 → 1.4 and maps to slowControl 1 → 0.6 (slower).
// With Settings → Fast Mode on, the same travel maps to 1 → 1.4, so the
// control speeds the video up instead. Either way the far end of the slider
// is "more effect", so the track and markers stay put.
export default function SlowControlSection({
  slowControl,
  speedUpMode = false,
  onSlowControlChange,
}) {
  const stepLabel = slowControl === 1 ? "None" : String(slowControl);
  const sliderValue = speedUpMode ? slowControl : 2 - slowControl;

  return (
    <div className="content__item content__item--slow">
      {/* Fast Mode crosses the word out rather than swapping the title, so it
          reads as the same control turned around. */}
      <div className="content__title">
        {speedUpMode ? (
          <>
            <s className="content__title-struck">Slow</s>
            <span>Fast Control</span>
          </>
        ) : (
          "Slow Control"
        )}
      </div>
      <ControlSlider
        label={stepLabel}
        markerPcts={CONTROL_SLIDER_MARKER_PCTS}
        min="1"
        max="1.4"
        step="0.01"
        value={sliderValue}
        ghostEnabled
        onChange={(event) => {
          const raw = parseFloat(event.currentTarget.value);
          const next = speedUpMode ? raw : 2 - raw;
          onSlowControlChange(parseFloat(next.toFixed(2)));
        }}
      />
    </div>
  );
}
